export type FooterLink =
  | {
      type: 'link';
      label: string;
      href: string;
      lang: string;
      target: '_blank';
    }
  | {
      type: 'cookies_management';
      label: string;
      lang: string;
    }
  | {
      type: 'copyright';
      label: string;
      lang: string;
    };
